import { Component, Input } from '@angular/core';
import { ConstantsService } from 'src/app/services/constants.service';

@Component({
  selector: 'app-dialog-legacy-download',
  templateUrl: './dialog-legacy-download.component.html',
  styleUrls: ['./dialog-legacy-download.component.css']
})
export class DialogLegacyDownloadComponent {

  @Input() viewType: string = this.constants.results_view_table;
  @Input() title?: string = '';
  @Input() accessionNumber?: string = '';
  @Input() microformAddress?: string = '';

  constructor(public constants: ConstantsService) {

  }
}
